module.exports = "//static.hsappstatic.net/connect-dot-com-ui-components/static-1.2818/images/logo/connect-dot-com-icon.svg"